module.exports = __webpack_public_path__ + "static/media/99a.6827a6c7.png";